<template>
  <div>
    <IconFiletypeAudio v-if="currentFiletypeComponent === 'audio'" />
    <IconFiletypeCode v-if="currentFiletypeComponent === 'code'" />
    <IconFiletypeCompressed v-if="currentFiletypeComponent === 'compressed'" />
    <IconFiletypeData v-if="currentFiletypeComponent === 'data'" />
    <IconFiletypeGeneric v-if="currentFiletypeComponent === 'generic'" />
    <IconFiletypeImage v-if="currentFiletypeComponent === 'image'" />
    <IconFiletypePDF v-if="currentFiletypeComponent === 'pdf'" />
    <IconFiletypePresentation v-if="currentFiletypeComponent === 'presentation'" />
    <IconFiletypeSpreadsheet v-if="currentFiletypeComponent === 'spreadsheet'" />
    <IconFiletypeText v-if="currentFiletypeComponent === 'text'" />
    <IconFiletypeVector v-if="currentFiletypeComponent === 'vector'" />
    <IconFiletypeVideo v-if="currentFiletypeComponent === 'video'" />
  </div>
</template>

<script>
import IconFiletypeAudio from './IconFiletypeAudio.vue'
import IconFiletypeCode from './IconFiletypeCode.vue'
import IconFiletypeCompressed from './IconFiletypeCompressed.vue'
import IconFiletypeData from './IconFiletypeData.vue'
import IconFiletypeGeneric from './IconFiletypeGeneric.vue'
import IconFiletypeImage from './IconFiletypeImage.vue'
import IconFiletypePDF from './IconFiletypePDF.vue'
import IconFiletypePresentation from './IconFiletypePresentation.vue'
import IconFiletypeSpreadsheet from './IconFiletypeSpreadsheet.vue'
import IconFiletypeText from './IconFiletypeText.vue'
import IconFiletypeVector from './IconFiletypeVector.vue'
import IconFiletypeVideo from './IconFiletypeVideo.vue'

const mapping = {
  'audio': ['mp3', 'wav'],
  'code': ['c', 'css'],
  'compressed': ['zip', 'tar.gz'],
  'data': ['json', 'db'],
  'image': ['jpg', 'jpeg'],
  'pdf': ['pdf'],
  'presentation': ['pptx', 'key'],
  'spreadsheet': ['xlsx', 'numbers'],
  'text': ['docx', 'pages'],
  'vector': ['svg', 'sketch'],
  'video': ['avi', 'mp4']
}

export default {
  name: 'IconFiletype',
  components: {
    IconFiletypeAudio,
    IconFiletypeCode,
    IconFiletypeCompressed,
    IconFiletypeData,
    IconFiletypeGeneric,
    IconFiletypeImage,
    IconFiletypePDF,
    IconFiletypePresentation,
    IconFiletypeSpreadsheet,
    IconFiletypeText,
    IconFiletypeVector,
    IconFiletypeVideo
  },
  props: {
    filename: String
  },
  computed: {
    currentFiletypeComponent () {
      const normalized = this.filename.toLowerCase()
      for (const key in mapping) {
        if (mapping.hasOwnProperty(key)) {
          const extensionList = mapping[key]
          for (const extension of extensionList) {
            if (normalized.endsWith(extension)) {
              return key
            }
          }
        }
      }
      return 'generic'
    }
  }
}
</script>
<style scoped>
svg {
  display: block;
  width: 36px;
  height: 36px;
  margin: 6px;
}
</style>
